import PropTypes from 'prop-types';
import { useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    IconButton,
    Button,
    Paper
} from '@mui/material';
import Iconify from 'src/components/iconify';

export default function TaskDescription({ description, onChange }) {
    const [ isEditing, setIsEditing ] = useState(false);
    const [ editValue, setEditValue ] = useState(description);

    const handleStartEdit = () => {
        setIsEditing(true);
        setEditValue(description);
    };

    const handleSave = () => {
        onChange(editValue);
        setIsEditing(false);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setEditValue(description);
    };

    return (
        <Box sx={ { mb: 3 } }>
            <Box sx={ {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 1
            } }>
                <Box sx={ { display: 'flex', alignItems: 'center' } }>
                    <Iconify icon="fluent:text-description-rtl-20-regular" sx={ { mr: 1 } } />
                    <Typography variant="subtitle2">Description</Typography>
                </Box>

                { !isEditing && (
                    <IconButton size="small" onClick={ handleStartEdit }>
                        <Iconify icon="eva:edit-outline" />
                    </IconButton>
                ) }
            </Box>

            { isEditing ? (
                <Box>
                    <TextField
                        fullWidth
                        multiline
                        minRows={ 3 }
                        maxRows={ 10 }
                        value={ editValue }
                        onChange={ (e) => setEditValue(e.target.value) }
                        variant="outlined"
                        size="small"
                        placeholder="Add a more detailed description..."
                        sx={ { mb: 2 } }
                    />

                    <Box sx={ { display: 'flex', gap: 1 } }>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={ handleSave }
                        >
                            Save
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={ handleCancel }
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            ) : (
                <Paper
                    variant="outlined"
                    sx={ {
                        p: 2,
                        minHeight: '80px',
                        cursor: 'pointer',
                        '&:hover': { bgcolor: 'action.hover' }
                    } }
                    onClick={ handleStartEdit }
                >
                    { description ? (
                        <Typography variant="body2">{ description }</Typography>
                    ) : (
                        <Typography variant="body2" color="text.secondary" sx={ { fontStyle: 'italic' } }>
                            Add a more detailed description...
                        </Typography>
                    ) }
                </Paper>
            ) }
        </Box>
    );
}

TaskDescription.propTypes = {
    description: PropTypes.string,
    onChange: PropTypes.func.isRequired
};